import gql from 'graphql-tag';
import {useMutation} from '@apollo/client';

const MUTATION = gql`
  mutation userNoteUpdate($userId: String!, $note: String!) {
    userNoteUpdate(userId: $userId, note: $note) {
      id
      attributes {
        code
        value
      }
    }
  }
`;

const useUserNoteUpdate = (
  onCompleted = (_response: any) => {
  },
  onError = (_error: any) => {
  }
) => {
  const [action] = useMutation(MUTATION, { onCompleted, onError });

  return (userId: string, note: string) => {
    return action({ variables: { userId, note } });
  };
};

export default useUserNoteUpdate;
